import React, { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { Box, Button, Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
import useTranslation from "components/customHooks/translations";
import { Formik } from "formik";
import CustomerForm from "./CustomerForm";
import { IUser } from "interfaces";
import LoadingIcon from "components/Feedback/LoadingIcon";
import { getUserById } from "services/users";

const EditCustomer = () => {
  const { pathname } = useLocation();
  const translation = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [customer, setCustomer] = useState<IUser | null>(null);
  const { customerId } = useParams();

  useEffect(() => {
    if (customerId !== undefined) {
      getUserById(customerId)
        .then((response) => {
          if (response.data) {
            setCustomer(response.data);
            setIsLoading(false);
          }
        })
        .catch((e) => console.log(e));
    }
  }, [customerId]);

  return (
    <Box>
      {isLoading || customer == null ? (
        <LoadingIcon />
      ) : (
        <>
          <CustomerForm userToEdit={customer}></CustomerForm>
        </>
      )}
    </Box>
  );
};

export default EditCustomer;
